module.exports = __webpack_public_path__ + "static/media/perfil-menu-mobile.3219ba64.svg";